// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"49":"gifs","443":"about","759":"stickers"}[chunkId] + "." + {"49":"6cdfad3a","443":"eabbf9bd","759":"84e9b1dc"}[chunkId] + ".css";
};